module.exports = __webpack_public_path__ + "static/media/defaultVideo.3858f50b.svg";